import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
const TeacherStats = ({ stats, events }) => {

    // Calculate additional statistics
    const calculateStats = () => {
        if (!events || events.length === 0) return {};

        const now = new Date();
        const thisWeek = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        const thisMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        const weeklyEvents = events.filter(event => new Date(event.start) >= thisWeek);
        const monthlyEvents = events.filter(event => new Date(event.start) >= thisMonth);

        const lessons = events.filter(event => event.extendedProps?.type === 'lesson');
        const completedLessons = lessons.filter(event => new Date(event.end) < now);
        const upcomingLessons = lessons.filter(event => new Date(event.start) > now);

        return {
            weeklyLessons: weeklyEvents.filter(e => e.extendedProps?.type === 'lesson').length,
            monthlyLessons: monthlyEvents.filter(e => e.extendedProps?.type === 'lesson').length,
            completedLessons: completedLessons.length,
            upcomingLessons: upcomingLessons.length,
            canceledEvents: (lessons.filter(e => e.status === 'canceled') ?? []).length
        };
    };

    const additionalStats = calculateStats();

    return (
        <div className="row gy-4">
            {/* Weekly Performance */}
            <div className="col-xxl-6 col-xl-6">
                <div className="card h-100">
                    <div className="card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="fw-bold text-lg mb-0">ביצועים שבועיים</h6>
                        <Link to="/widgets" className="text-primary-600 hover-text-primary d-flex align-items-center gap-1">
                            צפה בדו״חות
                            <Icon icon="solar:alt-arrow-left-linear" className="icon" />
                        </Link>
                    </div>
                    <div className="card-body p-24">
                        <div className="row gy-3">
                            <div className="col-6">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="w-40-px h-40-px bg-primary-100 rounded-circle d-flex align-items-center justify-content-center">
                                        <Icon icon="mdi:calendar-week" className="text-primary-600" />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-semibold">{additionalStats.weeklyLessons}</h6>
                                        <span className="text-sm text-secondary-light">שיעורים השבוע</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="w-40-px h-40-px bg-success-100 rounded-circle d-flex align-items-center justify-content-center">
                                        <Icon icon="mdi:check-circle" className="text-success-600" />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-semibold">{additionalStats.completedLessons}</h6>
                                        <span className="text-sm text-secondary-light">שיעורים הושלמו</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="w-40-px h-40-px bg-warning-100 rounded-circle d-flex align-items-center justify-content-center">
                                        <Icon icon="mdi:clock-outline" className="text-warning-600" />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-semibold">{additionalStats.upcomingLessons}</h6>
                                        <span className="text-sm text-secondary-light">שיעורים קרובים</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="w-40-px h-40-px bg-danger-100 rounded-circle d-flex align-items-center justify-content-center">
                                        <Icon icon="mdi:delete" className="text-danger-600" />
                                    </div>
                                    <div>
                                        <h6 className="mb-1 fw-semibold">{additionalStats.canceledEvents}</h6>
                                        <span className="text-sm text-secondary-light">שיעורים בוטלו</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Recent Activity */}
            <div className="col-xxl-6 col-xl-6">
                <div className="card h-100">
                    <div className="card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="fw-bold text-lg mb-0">אירועים שנוספו לאחרונה</h6>
                        <Link to="/calendar" className="text-primary-600 hover-text-primary d-flex align-items-center gap-1">
                            צפה בכל
                            <Icon icon="solar:alt-arrow-left-linear" className="icon" />
                        </Link>
                    </div>
                    <div className="card-body p-24">
                        {events && events.length > 0 ? (
                            <div className="d-flex flex-column gap-3">
                                {events
                                    .filter(event => new Date(event.end) < new Date())
                                    .slice(0, 4)
                                    .map((event, idx) => (
                                        <div key={event.id || idx} className="d-flex align-items-center gap-3 p-3 border rounded-3">
                                            <div className={`w-40-px h-40-px rounded-circle d-flex align-items-center justify-content-center ${event.extendedProps?.type === 'lesson' ? 'bg-primary-100' :
                                                event.extendedProps?.type === 'test' ? 'bg-success-100' :
                                                    'bg-secondary-100'
                                                }`}>
                                                <Icon
                                                    icon={
                                                        event.extendedProps?.type === 'lesson' ? 'mdi:car' :
                                                            event.extendedProps?.type === 'test' ? 'mdi:clipboard-check' :
                                                                'mdi:calendar'
                                                    }
                                                    className={
                                                        event.extendedProps?.type === 'lesson' ? 'text-primary-600' :
                                                            event.extendedProps?.type === 'test' ? 'text-success-600' :
                                                                'text-secondary-600'
                                                    }
                                                />
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-1 fw-medium">{event.title}</h6>
                                                <span className="text-sm text-secondary-light">
                                                    {new Date(event.start).toLocaleDateString('he-IL')} - {new Date(event.start).toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                                                </span>
                                            </div>
                                            <span className={`badge ${event.extendedProps?.type === 'lesson' ? 'bg-primary' :
                                                event.extendedProps?.type === 'test' ? 'bg-success' :
                                                    'bg-secondary'
                                                }`}>
                                                {event.extendedProps?.type === 'lesson' ? 'שיעור' :
                                                    event.extendedProps?.type === 'test' ? 'טסט' : 'אירוע'}
                                            </span>
                                        </div>
                                    ))}
                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <Icon icon="mdi:calendar-blank" className="text-4xl text-secondary-light mb-2" />
                                <p className="text-secondary-light">אין פעילות אחרונה</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeacherStats; 